import React, { useEffect, useState } from 'react';
import { CheckCircle2, Shield, Award, Leaf, MapPin } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const VerificationPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="verification-page">
      <div className="animated-bg"></div>
      <div className="floating-particles"></div>

      <header className="header">
        <div className="container">
          <img
            src="https://customer-assets.emergentagent.com/job_beast-original/artifacts/ua9rc6zw_photo_2026-02-26_16.27.16-removebg-preview.png"
            alt="Beast Root"
            className="logo"
          />
        </div>
      </header>

      <section className={`hero-section ${isVisible ? 'visible' : ''}`}>
        <div className="container">
          <div className="verification-badge">
            <div className="checkmark-wrapper">
              <CheckCircle2 className="checkmark-icon" />
              <div className="glow-effect"></div>
              <div className="sparkle sparkle-1"></div>
              <div className="sparkle sparkle-2"></div>
              <div className="sparkle sparkle-3"></div>
              <div className="sparkle sparkle-4"></div>
            </div>
            <h1 className="hero-title">Product Verified Successfully</h1>
            <p className="hero-subtitle">
              This Beast Root product is 100% safe, original, and authentic.
            </p>
            <p className="hero-thanks">
              Thank you for trusting Beast Root supplements.
            </p>
          </div>
        </div>
      </section>

      <section className="trust-section">
        <div className="container">
          <div className="trust-grid">
            <Card className="trust-card">
              <CardContent className="trust-card-content">
                <Shield className="trust-icon" />
                <h3>100% Genuine Product</h3>
                <p>Verified and authentic</p>
              </CardContent>
            </Card>
            <Card className="trust-card">
              <CardContent className="trust-card-content">
                <Award className="trust-icon" />
                <h3>Lab Tested Quality</h3>
                <p>Rigorous testing standards</p>
              </CardContent>
            </Card>
            <Card className="trust-card">
              <CardContent className="trust-card-content">
                <Leaf className="trust-icon" />
                <h3>Safe Ingredients</h3>
                <p>Pure and natural</p>
              </CardContent>
            </Card>
            <Card className="trust-card">
              <CardContent className="trust-card-content">
                <CheckCircle2 className="trust-icon" />
                <h3>Trusted Brand</h3>
                <p>Committed to excellence</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="brand-info-section">
        <div className="container">
          <Card className="brand-info-card">
            <CardContent className="brand-info-content">
              <h2 className="brand-name">Beast Root</h2>
              <div className="brand-details">
                <div className="brand-detail-item">
                  <p className="brand-label">Owner</p>
                  <p className="brand-value">Piyush Jain</p>
                </div>
                <div className="brand-detail-item">
                  <MapPin className="brand-icon" />
                  <p className="brand-value">Indore, India</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-badge">
              <Shield className="footer-shield" />
              <p>Protected by official verification system</p>
            </div>
            <p className="footer-copyright">
              © 2026 Beast Root. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VerificationPage;

